import React from 'react';
import type { DatePickerProps } from 'antd';
import { DatePicker, Space } from 'antd';
const onChange: DatePickerProps['onChange'] = (date, dateString) => {
    console.log(date, dateString);
  };

const RangeDatePicker = () => {
  return (
    <div>
        <DatePicker onChange={onChange} className='range-datepicker-col' />
      
    </div>
  )
}

export default RangeDatePicker
